/**
 * Utility functions for Process components
 */

/**
 * Helper function for sorting process data
 * @param {Object} a - First process data object to compare
 * @param {Object} b - Second process data object to compare
 * @param {string} orderBy - Field to sort by
 * @returns {number} Comparison result (-1, 0, 1)
 */
export function descendingComparator(a, b, orderBy) {
  // Handle special case for 'name' which is actually 'process_name'
  const aValue = a?.Process?.[orderBy] ?? (orderBy === 'name' ? a?.Process?.process_name : null);
  const bValue = b?.Process?.[orderBy] ?? (orderBy === 'name' ? b?.Process?.process_name : null);

  // Handle potential null/undefined values
  if (bValue == null) return -1;
  if (aValue == null) return 1;

  if (bValue < aValue) {
    return -1;
  }
  if (bValue > aValue) {
    return 1;
  }
  return 0;
}

/**
 * Returns a comparator function for sorting
 * @param {string} order - Sort order ('asc' or 'desc')
 * @param {string} orderBy - Field to sort by
 * @returns {Function} Comparator function
 */
export function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

/**
 * Formats byte values to human-readable format with appropriate units
 * @param {number} bytes - Byte value to format
 * @param {number} decimals - Number of decimal places
 * @returns {string} Formatted string with units
 */
export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0 || bytes == null) return '0 Bytes';
  
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/**
 * Table column definitions
 */
export const headCells = [
  { id: 'name', numeric: false, disablePadding: true, label: 'Process Name' },
  { id: 'process_id', numeric: true, disablePadding: false, label: 'PID' },
  { id: 'memory_usage', numeric: true, disablePadding: false, label: 'Memory' },
  { id: 'cpu_usage', numeric: true, disablePadding: false, label: 'CPU (%)' },
  { id: 'disk_usage', numeric: true, disablePadding: false, label: 'Disk' },
];
